import React, { useContext, useEffect, useState } from "react";

import PageContainer from "../../components/PageGeneralContainer/PageGeneralContainer";

import request from "../../utils/request.js";
import t from "../../utils/translation.js";
import LocalizationContext from "../../utils/LocalizationContext.js";

import styles from "./PackageRejectionReasons.module.css";

import ButtonQ from "../../components/ButtonQ/ButtonQ.js";
import { toast } from "react-toastify";
import PackageRejectionReasonsTable from "./PackageRejectionReasonsTable/PackageRejectionReasonsTable.jsx";
import PackageRejectionReasonsForm from "./PackageRejectionReasonsForm/PackageRejectionReasonsForm.jsx";
import PackageRejectionReasonsDetail from "./PackageRejectionReasonsDetail/PackageRejectionReasonsDetail.jsx";
import Redirect from "../../utils/Redirect";

const initialValue = {
  title: "",
  code: "",
  description: "",
  colorId: "",
};

const PackageRejectionReasons = () => {
  const [packagesRR, setPackagesRR] = useState([]);
  const [formData, setFormData] = useState(initialValue);

  const [modal, setModal] = useState(false);
  const [showDetail, setShowDetail] = useState(false);

  const [packageRR, setPackageRR] = useState({});
  const [loading, setLoading] = useState(true);

  const locale = useContext(LocalizationContext);


  const clearForm = () => {
    setFormData(initialValue);
  };

  const getPackagesRR = async () => {
    setLoading(true);
    try {
      let res = await request().get(`/api/location`);

      setPackagesRR(res.data);
    } catch (e) {
      toast.error(e.response?.data?.messagge);
    } finally {
      setLoading(false);
    }
  };



  const handleFormData = (data) => {
    setFormData(data);
  };

  const handleAdd = () => {
    setModal(true);
  };

  const handleClose = () => {
    setModal(false);
    clearForm();
  };

  const handleDetail = (data) => {
    setPackageRR(data);
    setShowDetail(true);
  };

  const handleCloseDetail = () => {
    setShowDetail(false);
    setPackageRR({});
  };

  useEffect(() => {
    getPackagesRR();
  }, []);

  return (
    <PageContainer
      title={t("LocationSpan") || "Package Rejection Reasons"}
      category={"sector"}
      pageStyles={true}
      backUrl={"/appdispatchmenu"}
      onClickBack={() =>
        Redirect({
          redirect: true,
          path: "/appdispatchmenu",
        })
      }
      clickBack={true}
    >
      <>
        <div className={styles.container}>
          <PackageRejectionReasonsTable
            packagesRR={packagesRR}
            getPackagesRR={getPackagesRR}
            handleData={setFormData}
            handleModal={setModal}
            handleDetail={handleDetail}
            loading={loading}
          />
          <div className={styles.detailContainer}>
            <ButtonQ
              caption={t("AddButton") || "Add"}
              onClick={() => handleAdd()}
            />
          </div>
        </div>
      </>

      <PackageRejectionReasonsForm
        formData={formData}
        handleFormData={handleFormData}
        handleClose={handleClose}
        open={modal}
        getPackagesRR={getPackagesRR}
        t={t}
        locale={locale}
      />

      <PackageRejectionReasonsDetail
        open={showDetail}
        handleClose={handleCloseDetail}
        t={t}
        locale={locale}
        packageRR={packageRR}
      />
    </PageContainer>
  );
};

export default PackageRejectionReasons;
